import type { NewReportKey, ReportKey, ReportRegistryResponse } from '@cabgo/shared';
import { SERVICE_JOB_DETAIL_COLUMNS } from './reportDefinitions';
import { buildServiceJobDetailExportBody, buildServiceJobDetailPreviewPath } from './reportParams';
import type { ReportViewDefinition } from './reportViewTypes';
import { cancelledServicesView } from './views/cancelled_services';
import { dailyDriverServiceView } from './views/daily_driver_service';
import { dailyServiceFrequencyView } from './views/daily_service_frequency';
import { driverAssignmentDetailView } from './views/driver_assignment_detail';
import { missedServicesView } from './views/missed_services';
import { serviceFrequencyTodayView } from './views/service_frequency_today';
import { serviceUsersView } from './views/service_users';
export const REPORT_TABLE_VIEWS: Record<NewReportKey, ReportViewDefinition> = {
  cancelled_services: cancelledServicesView,
  missed_services: missedServicesView,
  daily_service_frequency: dailyServiceFrequencyView,
  service_frequency_today: serviceFrequencyTodayView,
  daily_driver_service: dailyDriverServiceView,
  driver_assignment_detail: driverAssignmentDetailView,
  service_users: serviceUsersView,
};

export const REPORT_LABEL_KEYS: Record<ReportKey, string> = {
  service_job_detail: 'serviceJobDetail',
  cancelled_services: 'cancelledServices',
  missed_services: 'missedServices',
  daily_service_frequency: 'dailyServiceFrequency',
  service_frequency_today: 'serviceFrequencyToday',
  daily_driver_service: 'dailyDriverService',
  driver_assignment_detail: 'driverAssignmentDetail',
  service_users: 'serviceUsers',
};

export const SERVICE_JOB_DETAIL_ADAPTER = {
  key: 'service_job_detail',
  titleKey: 'serviceJobDetail',
  descriptionKey: 'serviceJobDetailDesc',
  dateBasisKey: 'dateBasis',
  historyLabelKey: 'serviceJobDetail',
  previewPath: buildServiceJobDetailPreviewPath,
  exportPath: '/reports/service_job_detail/exports',
  exportBody: buildServiceJobDetailExportBody,
  columns: SERVICE_JOB_DETAIL_COLUMNS,
  summary: [
    { labelKey: 'summaryTrips', field: 'rowCount', money: false },
    { labelKey: 'summaryFare', field: 'fareTotalSum', money: true },
    { labelKey: 'summaryBilled', field: 'billedTotalSum', money: true },
    { labelKey: 'summaryReceived', field: 'receivedTotalSum', money: true },
    { labelKey: 'summaryOutstanding', field: 'outstandingTotalSum', money: true },
    { labelKey: 'summaryReview', field: 'financeReviewCount', money: false },
  ],
} as const;

type ReportRegistryEntry = ReportRegistryResponse['data'][number];

export function reportRegistryPath(superAdmin: boolean, activeProviderId: string | null): string {
  return superAdmin && activeProviderId
    ? `/reports?targetProviderId=${encodeURIComponent(activeProviderId)}`
    : '/reports';
}

export function isRegistryReportOpen(entry: ReportRegistryEntry | undefined): boolean {
  return Boolean(entry?.allowed && entry.availability === 'AVAILABLE');
}

export function hasOpenRegistryReport(registry: ReportRegistryResponse | undefined): boolean {
  return registry?.data.some(isRegistryReportOpen) ?? false;
}

export type { ReportRegistryResponse };
